<template>
  <div class="input-group w-auto">
    <button class="btn btn-outline-primary" type="button" @click="localQuantity = Math.max(1, localQuantity - 1)">
      <i class="bi bi-dash"></i>
    </button>
    <select v-if="localQuantity < 10" v-model.lazy="localQuantity" class="form-select pe-3" style="width: 6rem">
      <option v-for="i in [1, 2, 3, 4, 5, 6, 7, 8, 9]" :key="i">
        {{ i }}
      </option>
      <option value="10">10+</option>
    </select>
    <input v-else v-model.lazy="localQuantity" type="number" class="form-control" style="width: 6rem" />
    <button class="btn btn-outline-primary" type="button" @click="localQuantity++">
      <i class="bi bi-plus"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: { type: Number, default: 0 },
  },
  emits: ['update:modelValue'],
  setup() {
    return {};
  },
};
</script>
